import React from 'react';
import { Navigate } from 'react-router-dom';

// A wrapper component for protecting routes
const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const token = localStorage.getItem('authToken');

  // Check if the token exists, if not, redirect to login
  if (!token) {
    return <Navigate to="/otp-verify" />;
  }

  // If token exists, allow access to the child component (protected page)
  return children;
};

export default ProtectedRoute;
